/**
 * Dialog component.
 *
 * @param {HTMLElement} dialog The dialog element.
 */
const dialog = (dialog) => {
  if (!dialog) {
    return;
  }

  const toggles = document.querySelectorAll( `[aria-controls="${dialog.id }"]` );
  const closeDialogButton = document.getElementById( `${dialog.id}-close`);

  const opensDialog = () => {
    dialog.showModal();
    closeDialogButton.focus();

    toggles?.forEach( btn => btn.setAttribute( 'aria-expanded', 'true' ) );
  };

  const closesDialog = () => {
    dialog.close();
    toggles[0].focus();

    toggles?.forEach( btn => btn.setAttribute( 'aria-expanded', 'false' ) );
  }

  toggles?.forEach( btn => btn.addEventListener( 'click', opensDialog ) );
  closeDialogButton.addEventListener( 'click', closesDialog );

  // Close dialog with Escape key.
  dialog.addEventListener( 'keydown', (event) => {
    if (event.key === 'Escape') {
      closesDialog();
    }
  } );
}

export default dialog;
